<template>
  <div class="customer-detail">
    <div style="background: #ff8d89; padding: 10px 0 10px 0">
      <slot name="header"></slot>
    </div>
    <template v-if="!loading">
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <div>{{ $t('general_information') }}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('customer_name') }}</label>
          <div>
            <template v-if="user.th_name">
              {{ user.th_name }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('Id Card') }}</label>
          <div>
            <template v-if="user.id_no">
              {{ user.id_no }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('account_no') }}</label>
          <div>
            <template v-if="user.account_no">
              {{ user.account_no }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('card_no_amoney') }}</label>
          <div>
            <template v-if="user.card_no_amoney">
              {{ user.card_no_amoney }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <div>{{ $t('general_information') }}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('UID') }}</label>
          <div>
            <template v-if="user.th_name">
              {{ user.uid }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('line_name') }}</label>
          <div>
            <template v-if="user.first_name">
              {{ user.first_name }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('account_binding_status') }}</label>
          <div>
            <span v-html="handleGetStatusColor(user.member_status)"></span>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('regis_date') }}</label>
          <div>
            <!-- <template v-if="user.regis_date">
              {{ user.regis_date }}
            </template>
            <template v-else>-</template> -->
            {{ user.regis_date ? getFormatDate(user.regis_date, 'DD/MM/YYYY') : '-' }}
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('update_address_date') }}</label>
          <div>
            {{
              user.update_address_date ? getFormatDate(user.update_address_date, 'DD/MM/YYYY') : '-'
            }}
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('update_phone_date') }}</label>
          <div>
            {{ user.update_phone_date ? getFormatDate(user.update_phone_date, 'DD/MM/YYYY') : '-' }}
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('cancel_regis_date') }}</label>
          <div>
            {{ user.cancel_regis_date ? getFormatDate(user.cancel_regis_date, 'DD/MM/YYYY') : '-' }}
          </div>
        </v-flex>
      </v-layout>
      <v-divider></v-divider>

      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <div>{{ $t('bank_information') }}</div>
        </v-flex>
      </v-layout>
      <v-layout wrap>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('prompt_pay') }}</label>
          <div>
            <template v-if="user.prompt_pay">
              {{ user.prompt_pay }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('bank_account_no') }}</label>
          <div>
            <template v-if="user.bank_account_no">
              {{ user.bank_account_no }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('bank_name') }}</label>
          <div>
            <template v-if="user.bank_name">
              {{ user.bank_name }}
            </template>
            <template v-else>-</template>
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('update_bank_date') }}</label>
          <div>
            {{ user.update_bank_date ? getFormatDate(user.update_bank_date, 'DD/MM/YYYY') : '-' }}
          </div>
        </v-flex>
        <v-flex xs6 class="pl-3 pr-3 pt-2 pb-2">
          <label class="caption" for>{{ $t('bank_account_status') }}</label>
          <div>
            <span v-html="handleGetStatusBankColor(user.bank_account_status)"></span>
          </div>
        </v-flex>
      </v-layout>

      <v-divider></v-divider>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import moment from 'moment'

export default {
  components: {},
  props: {
    value: {
      default: undefined
    },
    pageid: {
      default: undefined
    }
  },
  data: function () {
    return {
      loading: false,
      user: {}
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab',
      currentLang: 'currentLang'
    })
  },
  watch: {
    value: function () {
      this.user = this.value
    }
  },
  async mounted() {
    this.user = this.value
  },
  methods: {
    getFormatDate: function (date, format) {
      return moment(date).format(format)
    },
    statusDisplay: function (value) {
      let status = ''
      if (value === 'active') {
        status = 'ผูกบัญชี'
      } else {
        status = 'ยกเลิกผูกบัญชี'
      }
      return status
    },
    handleGetStatusColor(status) {
      if (status) {
        let color = ''
        switch (status) {
          case 'active':
            color = 'success'
            break
          case 'inactive':
            color = 'error'
            break

          default:
            color = 'primary'
            break
        }
        let tmpStatus = ''
        if (status) {
          tmpStatus = this.statusDisplay(status)
          return `<span class="${color}--text">${tmpStatus}</span>`
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    },
    statusBankDisplay: function (value) {
      let status = ''
      if (value.toLowerCase() === 'active') {
        status = 'เปิดใช้งาน'
      } else {
        status = 'รอการตรวจสอบ'
      }
      return status
    },
    handleGetStatusBankColor(status) {
      if (status) {
        let color = ''
        console.log(status)
        switch (status.toLowerCase()) {
          case 'active':
            color = 'success'
            break
          case 'waiting_to_approve':
            color = 'yellow'
            break

          default:
            color = 'primary'
            break
        }
        let tmpStatus = ''
        if (status) {
          tmpStatus = this.statusBankDisplay(status)
          return `<span class="${color}--text">${tmpStatus}</span>`
        } else {
          return '-'
        }
      } else {
        return '-'
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/AiraAiful/TicketMemberDetail.vue